export interface Name {
    companyName: string;
    customerName: string;
    firstName: string;
    lastName: string;
    displayName: string;  
    greetingName: string;
}

export const initialStateName: Name = { companyName: '', customerName: '', firstName: '', lastName: '', displayName: '', greetingName:''};

export interface Address {
    line1: string;
    line2: string;
    city: string;
    state: string;
    zip: string;
    country: string;
}

export const initialStateAddress: Address = {
    line1: '',
    line2: '',
    city: '',
    state: '',
    zip: '',
    country: ''};


export interface PhoneNumbers {
    homePhone: string;
    workPhone: string;
    workPhoneExtn: string;
    personalCellPhone: string;
    officeCellPhone: string;
    displayPhone: string;
}


export const initialStatePhoneNumber: PhoneNumbers = {
    homePhone:'',
    workPhone:'',
    workPhoneExtn:'',
    personalCellPhone:'',
    officeCellPhone: '',
    displayPhone:''
};


export interface ErrorModel {
    clientMessage: string,
    message:string,
    errorCode: number,
    stackTrace: string,
    source: string
}

export const initialStateErrorModel: ErrorModel = {
    clientMessage: '',
    message: '',
    errorCode: -1,
    stackTrace: '',
    source: ''
}

//export interface HttpResultBase {
//    errorInfo: ErrorModel
//}

//export const initialHttpResultBase: HttpResultBase = {
//    errorInfo: initialStateErrorModel
//}

